export const TOASTY_DISPLAY_DURATION = 3000 // 3 seconds
export const TOASTY_ANIMATION_DURATION = 400 // 300ms + 100 for good measure
